<template>
  <div>
    <custom-dialog width="407px" v-if="show" :visible="show" @close="close">
      <div slot="header">
        <div class="header">
          <img :src="imgArr.statusBg3" class="bg-img">
          <div class="header-patient">
            <span class="mr20">{{ dialogObj.patientName }}</span>
            <span class="mr20">{{ dialogObj.sex == '0' ? '男' : '女' }}</span>
            <span class="mr20">{{ dialogObj.age }}岁{{ dialogObj.ageMth }}月</span>
            <span>{{ dialogObj.phone }}</span>
          </div>
        </div>
      </div>
      <div class="content" slot="content">
        <div>执行医生：{{ dialogObj.doctorName }}</div>
        <div class="mt12 price-item">预约时间： {{ dialogObj.schedulingTime }} {{ dialogObj.reservationStartTime }} - {{
          dialogObj.reservationEndTime }}</div>
        <div class="mt12 price-item">预约项目：{{ dialogObj.physioNames }} </div>
        <div class="mt12 price-item">预约时长：{{ dialogObj.estimatedDuration }}分钟 </div>
        <div class="mt12">创建：{{ dialogObj.createBy }}（{{ dialogObj.createTime }}）</div>
        <div v-if="dialogObj.status == '2' && dialogObj.cancelBy" class="mt12">取消：{{ dialogObj.cancelBy }}（{{ dialogObj.cancelTime }}）</div>
      </div>
      <div class="footer" slot="footer">
        <custom-button v-if="dialogObj.schedulingTime == today && [1].includes(dialogObj.status) && dialogObj.source != 'platform-intermediary'" size="small" type="primary" @click="physioSignAndPrint">签到并打印</custom-button>
        <custom-button v-if="dialogObj.schedulingTime == today && [1].includes(dialogObj.status) && dialogObj.source != 'platform-intermediary'" size="small" type="primary" :loading="signLoading" @click="physioSign">签到</custom-button>
        <custom-button v-if="dialogObj.schedulingTime == today && [1].includes(dialogObj.status) && dialogObj.source == 'platform-intermediary' && !dialogObj.isRegistered" size="small" type="primary" @click="openRedeem">验券并挂号</custom-button>
        <custom-button size="small" type="info" v-if="(dialogObj.source !== 'platform-intermediary' && [3, 6].includes(dialogObj.status)) || (dialogObj.source === 'platform-intermediary' && [1, 3, 6].includes(dialogObj.status) && dialogObj.isRegistered)" @click="print">打印</custom-button>
        <custom-button size="small" type="info" v-if="[1, 4, 6].includes(dialogObj.status) && !dialogObj.isRegistered && !(dialogObj.voucherInfos && dialogObj.voucherInfos.length > 0)" @click="cancel">取消预约</custom-button>
        <custom-button size="small" type="info" @click="close">关闭</custom-button>
      </div>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from '@/components/customDialog/CustomDialog'
import { msgboxWarning } from '@/utils/validateBase'
import { imgArr } from '@/assets/images/img'
import { cancelReservation } from '@/api/register'
import req from '@/utils/request'
export default {
  // 定义引入的组件
  components: { CustomDialog },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    dialogObj: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {
      today: new Date().Format('yyyy-MM-dd'),
      imgArr: imgArr,
      statusObj: {},//当前状态对象
      sourceConfigList: [],
      signLoading: false
    }
  },
  //变量监听
  watch: {},
  // 页面初始化
  async created() {
    
  },
  computed: {
  },
  // 页面DOM加载完成
  mounted() { },
  //离开页面时执行
  destroyed() { },
  // 页面方法
  methods: {
    close() {
      this.$emit('close')
    },
    cancel() {
      msgboxWarning(this, {
        message: "是否确定取消当前预约？",
        confirmFn: async () => {
          let { code,data } = await cancelReservation({reservationId:this.dialogObj.id})
          if(code == 200){
            this.$emit('close',true)
          }
        },    
        cancelFn: () => {
        }
      })
    },
    openRedeem () {
      this.$emit('openRedeem', this.dialogObj.id, this.dialogObj.schedulingTime)
    },
    async physioSign () {
      this.signLoading = true
      const res = await req.post('/physio/signIn/checkIn', {
        reservationId: this.dialogObj.id,
        checkinType: 2
      })
      this.signLoading = false
      if(res.code == 200){
        this.$message.success('签到成功')
        this.$emit('close', true)
      }
    },
    async physioSignAndPrint () {
      const res = await req.post('/physio/signIn/checkIn', {
        reservationId: this.dialogObj.id,
        checkinType: 2
      })
      this.signLoading = false
      if(res.code == 200){
        this.$message.success('签到成功')
        this.$emit('close', true)
        this.$emit('print', this.dialogObj.id)
      }
    },
    async print () {
      this.$emit('print', this.dialogObj.id)
    }
  },
}
</script>
<style lang="less">
.price-popover {
  background: #FFFDE9;
  padding: 10px;
  box-sizing: border-box;
  font-size: 13px;
  padding-bottom: 0;

  .price-top {
    padding-bottom: 8px;
    color: #000;
  }

  .price-bottom {
    border-top: 1px dashed #E0E0E0;
    padding-top: 8px;
    color: #667182;
    padding-bottom: 8px;
  }
}
</style>
<style lang="less" scoped>
.lockset-tips {
  height: 32px;
  background: #FFFDE9;
  line-height: 32px;
  text-align: center;
  font-weight: 400;
  color: #FE8F1F;
}

/deep/.el-dialog__body {
  padding-top: 0 !important;
}

.header {
  height: 56px;
  padding: 12px 16px;
  box-sizing: border-box;
  position: relative;

  .bg-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 407px;
  }

  .header-patient {
    position: relative;
    z-index: 2;
    padding: 6px 12px;
    box-sizing: border-box;
    color: #1F2329;
    font-size: 14px;
    border-radius: 2px;
    background-color: #F3FAFF;
  }
}

.content {
  color: #000;

  .rigth-line {
    padding-right: 6px;
    padding-left: 3px;
    border-right: 1px solid #EBEAEE;
    flex-grow: 0;
    flex-shrink: 0;

    &:last-child {
      border-right: none
    }

    &:first-child {
      padding-left: 0;
    }
  }
}

.footer {
  margin-top: 18px;
  padding-bottom: 16px;
  text-align: right;
  padding-right: 24px;

}

.footer-tips {
  color: #667182;
  margin-top: 18px;
  padding: 0 24px;
  padding-bottom: 16px;
}
</style>